import { api } from "./api";
import type { OnboardingChecklist } from "@/types/models";

export const onboardingService = {
  // Derived new-owner setup checklist (Phase 7). Owner-only.
  get: (): Promise<OnboardingChecklist> => api.get<OnboardingChecklist>("/onboarding").then((r) => r.data),
};
